import React from "react";
import QuantityPickerSmall$ from "@deosite/components-new/quantityPickers/QuantityPickerSmall";

const QuantityPickerSmall = props => <QuantityPickerSmall$ {...props} />;

export default QuantityPickerSmall;
